(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_hex-custom-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hex-image-gallery')) {
    customElements.define('hex-image-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.layoutFrame);
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('[data-hex-gallery-track]');
        this.previous = this.querySelector('[data-hex-gallery-previous]');
        this.next = this.querySelector('[data-hex-gallery-next]');
        this.count = this.querySelector('[data-hex-gallery-count]');
        if (!this.track) return;
        this.pendingVariant = this.dataset.initialVariant || '';
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-hex-gallery-slide]');
          if (slide && this.contains(slide)) {
            this.pendingVariant = '';
            this.show(slide);
          }
        }, options);
        const section = this.closest('.shopify-section');
        (section || document).addEventListener('variant:update', (event) => {
          const productId = event.detail?.data?.productId;
          if (!section && !productId) return;
          if (productId && String(productId).split('/').pop() !== this.dataset.productId) return;
          const title = event.detail?.resource?.title;
          if (typeof title !== 'string') return;
          this.pendingVariant = title;
          this.scheduleLayout();
        }, options);
        this.resize = new ResizeObserver(() => this.scheduleLayout());
        this.resize.observe(this.track);
        this.update();
        this.scheduleLayout();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.layoutFrame);
      }
      get slides() { return [...this.track.querySelectorAll('[data-hex-gallery-slide]')]; }
      get currentIndex() {
        const edge = this.track.getBoundingClientRect().left;
        return this.slides.reduce((best, slide, index, slides) =>
          Math.abs(slide.getBoundingClientRect().left - edge) < Math.abs(slides[best].getBoundingClientRect().left - edge) ? index : best, 0);
      }
      scheduleLayout() {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          if (this.pendingVariant && this.track.clientWidth > 0) {
            const title = this.pendingVariant.trim();
            const matchingSlide = this.slides.find((slide) =>
              slide.dataset.hexVariantTitle?.trim() === title);
            this.pendingVariant = '';
            if (matchingSlide) this.show(matchingSlide, 'instant');
          }
          this.update();
        });
      }
      show(slide, behavior) {
        const left = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
        this.track.scrollTo({ left, top: this.track.scrollTop, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth') });
        this.update();
      }
      move(direction) {
        this.pendingVariant = '';
        const slides = this.slides;
        const index = Math.max(0, Math.min(slides.length - 1, this.currentIndex + direction));
        if (slides[index]) this.show(slides[index]);
      }
      update() {
        const slides = this.slides;
        const index = this.currentIndex;
        this.querySelector('[data-hex-gallery-controls]').hidden = slides.length < 2;
        this.count.textContent = `${slides.length ? index + 1 : 0} / ${slides.length}`;
        this.previous.disabled = index === 0;
        this.next.disabled = index >= slides.length - 1;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
